import { Company } from "./useCompany";

export enum CountryISOCode {
  PORTUGAL = "PT",
  SPAIN = "ES",
  MEXICO = "MX",
}

interface DeliveryAddress {
  streetName: string;
  streetNumber: string;
  details: string | null;
  street: string;
  postalCode: string;
  province: string;
  locality: string;
  district: string;
}

interface Country {
  countryId: string;
  ISO2Code: CountryISOCode;
  currency: string;
  language: string;
  regions: string[];
  standardWorkableDays: number;
  workableHoursPerDay: number;
}

interface CompanyBackend {
  id: string;
  companyName: string;
  companyLegalName: string;
  legalId: string;
  deliveryAddress: DeliveryAddress;
  pricingType: string;
  country: Country;
  mustIssueCard: boolean;
  benefitConfigs: Record<string, unknown>;
}

const restoreCompany = (company: CompanyBackend): Company => {
  return {
    name: company.companyLegalName,
    country: company.country.ISO2Code,
  };
};

export { restoreCompany };
